// src/helpers/productHelper.js
export const hasMsrpDiscount = (product) => {
	return product.data.msrp && product.data.msrp > product.data.price;
};
